export default __webpack_public_path__ + "static/media/area.93f86b33.svg";